import React from 'react';
import {
    getFileRefIcon,
    getSnippetExtension,
    getSnippetIcon,
} from '../../shared/utils/getFileIconAndExtensionHelper';

export type RoomPreviewItem = {
    id: string;
    kind: 'file' | 'snippet';
    name: string;
    fileType?: string;
    fileExtension?: string;
    mime?: string;
    snippetLanguage?: string;
    snippetType?: string;
};

type RoomResourcePillsProps = {
    items?: RoomPreviewItem[];
};

function imageFileName(iconName: string) {
    return iconName.includes('.') ? iconName : `${iconName}.png`;
}

function getPreviewIcon(item: RoomPreviewItem) {
    if (item.kind === 'snippet') {
        return imageFileName(getSnippetIcon(item.snippetLanguage || 'text'));
    }

    return imageFileName(getFileRefIcon(item.name));
}

function getPreviewLabel(item: RoomPreviewItem) {
    if (item.kind === 'snippet') {
        const extension = getSnippetExtension(item.snippetLanguage || 'text');
        return `${item.name}.${extension}`;
    }

    return item.name;
}

function RoomResourcePills({ items = [] }: RoomResourcePillsProps) {
    if (!items.length) {
        return (
            <div className="room-preview-pills empty">
                <span className="room-preview-empty">No files yet</span>
            </div>
        );
    }

    return (
        <div className="room-preview-pills">
            {items.slice(0, 5).map((item) => (
                <span className="room-preview-pill" key={`${item.kind}-${item.id}`}>
                    <img
                        src={`${process.env.PUBLIC_URL}/images/${getPreviewIcon(item)}`}
                        alt=""
                    />
                    <span title={getPreviewLabel(item)}>{getPreviewLabel(item)}</span>
                </span>
            ))}
        </div>
    );
}

export default RoomResourcePills;
